import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import AppModal from '@/_core/shared/ui/AppModal/AppModal.vue';
import IconClose from '@/assets/images/svg/icon-close.svg?component';


export default /*#__PURE__*/_defineComponent({
  __name: 'LlmFeedbackCommentModal',
  props: {
    isOpen: { type: Boolean },
    isPending: { type: Boolean }
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', comment: string): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  isPending?: boolean;
};





const comment = ref('');
const hasError = ref(false);

function resetComment(): void {
  comment.value = '';
  hasError.value = false;
}

watch(
  () => props.isOpen,
  (open) => !open && resetComment()
);

watch(comment, () => {
  if (hasError.value) hasError.value = false;
});

function handleSubmit(): void {
  if (props.isPending) return;

  const value = comment.value.trim();

  if (!value) {
    hasError.value = true;
    return;
  }

  emit('submit', value);
  resetComment();
}

function clearAndClose(): void {
  resetComment();
  emit('close');
}

return { __sfc: true,props, emit, comment, hasError, resetComment, handleSubmit, clearAndClose, AppModal, IconClose }
}

})